<div class="barra-acoes-funcionalidade" [ngClass]="classe">
  <smk-header-default [showShadow]="true">
    <button class="voltar btn btn-outline-primary" ngbTooltip="Voltar" container="body" (click)="volte()" aria-label="voltar"><i class="fas fa-chevron-left"></i></button>
    <div *ngIf="acoes.hasChildNodes()" class="separador ms-2 me-3">&nbsp;&nbsp;</div>
    <div class="acoes" #acoes>
      <ng-content></ng-content>
    </div>
  </smk-header-default>
</div>
